function extractColorFromScale({
  variant,
  percent,
  data,
  config,
  configLine,
  theme,
}) {
  const escalasMap = {
    trafego: config?.escalas?.trafego,
    potencia: config?.escalas?.potencia,
    ftth: config?.escalas?.ftth,
  };
  const off = {
    cor: theme.palette.enlaces.offline.main,
    label: "Offline",
  };

  const escalaCor = escalasMap[variant];

  if (!escalaCor) {
    return off;
  }

  let corCorrespondente;

  if (variant === "trafego") {
    const isInvalidInput =
      percent == null ||
      percent === 0 ||
      percent === Infinity ||
      !config?.escalas;
    if (isInvalidInput) {
      return off;
    }
    corCorrespondente = escalaCor
      .filter((escala) => parseFloat(escala?.label) <= percent)
      .pop();
  } else if (variant === "potencia") {
    let tx = data?.potencia?.tx;
    let rx = data?.potencia?.rx;
    if (isNaN(rx) || isNaN(tx)) {
      return (corCorrespondente = escalaCor[0]);
    }

    const thresholds = configLine?.flagLimiteAutomatico
      ? { ...data?.potencia?.thresholds }
      : {
          lowTx: configLine?.limiteInferiorPowerTX,
          hightTx: configLine?.limiteSuperiorPowerTX,
          lowRx: configLine?.limiteInferiorPowerRX,
          hightRx: configLine?.limiteSuperiorPowerRX,
        };
    const isInvalidPower =
      thresholds?.hightTx === null ||
      thresholds?.hightTx === Infinity ||
      thresholds?.lowTx === null ||
      thresholds?.lowTx === Infinity ||
      thresholds?.hightRx === null ||
      thresholds?.hightRx === Infinity ||
      thresholds?.lowRx === null ||
      thresholds?.lowRx === Infinity;

    if (isInvalidPower && variant === "potencia") {
      return off;
    }

    const qualityTx =
      tx < thresholds?.lowTx ? 1 : tx < thresholds?.hightTx ? 2 : 3;

    const qualityRx =
      rx < thresholds?.lowRx ? 1 : rx < thresholds?.hightRx ? 2 : 3;

    //pega o menor valor entre tx e rx
    const quality = Math.min(qualityTx, qualityRx);

    corCorrespondente = escalaCor[quality];
  }
  return corCorrespondente || off;
}
export default extractColorFromScale;
